/* @flow */
import React from 'react';

import LoadingIndicator from 'components/LoadingIndicator.jsx';

import cx from 'classnames';

import './styles/Field.scss';

/**
  * Component used in forms in order to show error messages.
  */


class Field extends React.Component {
  static propTypes = {
    inline: React.PropTypes.bool,
    error: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.bool,
    ]),
    warning: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.element,
    ]),
    loading: React.PropTypes.bool,
  };

  static defaultProps = {
    inline: false,
    // $FlowIssue
    error: false,
    loading: false,
  };

  render() {
    let error;
    if (typeof this.props.error === 'string') {
      error = <div className="Field-error">{this.props.error}</div>;
    } else if (this.props.warning) {
      error = <div className="Field-warning">{this.props.warning}</div>;
    }

    return (
      <div
        className={cx({
          Field: true,
          'Field-hasError': !!this.props.error,
          'Field-hasWarning': !this.props.error && !!this.props.warning,
          'Field-inline': this.props.inline,
        }, this.props.className)}>
        {this.props.children}
        {error}
        {this.props.loading && <LoadingIndicator className="Field-loading" />}
      </div>
    );
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/Field.jsx